import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'

interface ProtectedRouteProps {
  children: React.ReactNode
  requireCompany?: boolean // เช่น /post-job — individual ล็อกอินแล้วก็เข้าไม่ได้ ต้องเป็น COMPANY เท่านั้น
}

// ครอบ route ที่บังคับ login ก่อน — ยังไม่ login ให้เด้งไปหน้า /login พร้อมจำ path เดิมไว้ redirect กลับหลัง login สำเร็จ
// (การบังคับ onboarding ของบริษัททำที่ OnboardingGate ระดับทั้งแอปแล้ว ไม่ต้องเช็คซ้ำที่นี่)
export default function ProtectedRoute({ children, requireCompany }: ProtectedRouteProps) {
  const isLoggedIn = useAuthStore((s) => s.isLoggedIn)
  const customerType = useAuthStore((s) => s.customerType)
  const location = useLocation()

  if (!isLoggedIn) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  if (requireCompany && customerType !== 'COMPANY') {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
